<template>
    <el-dialog v-dialogDrag width="500px" :top="this.$tools.topheight(100)" :title="title"
        class="dataroom-el-dialog dialogClass" :visible.sync="dialogFormVisible" :append-to-body="true"
        :before-close="handleClose">
        <div style="margin: 20px">
            <el-form ref="ruleForm" :model="dataForm" :rules="rules" label-position="right" label-width="90px"
                class="bs-el-form">
                <!-- <el-form-item label="父级分组">
                    <type-select ref="typeSelect" :type="editType" :type-id="dataForm.parentId" :child-id="dataForm.id" />
                </el-form-item> -->
                <el-form-item label="分组名称" prop="name">
                    <el-input v-model.trim="dataForm.name" class="bs-el-input" clearable />
                </el-form-item>
            </el-form>
        </div>

        <span slot="footer" class="dialog-footer">
            <el-button class="bs-el-button-default" @click="cancel"> 取消 </el-button>
            <el-button type="primary" @click="submitForm('ruleForm')">
                确定
            </el-button>
        </span>
    </el-dialog>
</template>

<script>
import TypeSelect from '@/components/data-room-ui/packages/dataSet/components/TypeSelect.vue'
import {
    categoryAdd,
    categoryUpdate
} from '../assets/js/datasetConfigService'
export default {
    name: 'CategroyEditForm',
    components: {
        TypeSelect
    },
    props: {
        appCode: {
            type: String,
            default: ''
        },
        treeData: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            type: 'dataset',
            editType: '',
            dataForm: {
                id: '',
                name: '',
                parentId: ''
            },
            title: '',
            dialogFormVisible: false,
            radio: 0,
            nodeFlag: false,
            rules: {
                name: [
                    { required: true, message: '分组名称不能为空', trigger: 'blur' },
                ]
            },
            nodeData: {}
        }
    },
    watch: {
        dialogFormVisible(val) {
            if (!val) {
                this.dataForm = {
                    id: '',
                    name: '',
                    parentId: ''
                }
            }
        }
    },
    methods: {

        init(row, flag, editType) {
            if (editType) {
                this.editType = editType
                if (this.editType == 'addChildOrg') {
                    this.dataForm.parent_code = row.code
                } else if (this.editType == "editOrg") {
                    this.dataForm = row
                }
            }
            this.nodeFlag = flag
        },
        cancel() {
            this.dialogFormVisible = false
            this.$nextTick(() => {
                this.$parent.addOrUpdateTreeVisible = false
            })
        },
        handleClose() {
            this.dialogFormVisible = false
            this.$parent.addOrUpdateTreeVisible = false
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    let id = ''
                    // const parentId = this.$refs.typeSelect.typeIdCopy
                    if (!this.nodeFlag) {
                        id = this.dataForm.code
                    }
                    const data = {
                        enterprise: localStorage.getItem('enterprise_id'),
                        type: '4',
                        ...this.dataForm,
                    }
                    if (id) {
                        categoryUpdate({ data }).then((r) => {
                            this.$message({
                                type: 'success',
                                message: '编辑成功'
                            })
                            this.cancel()
                            try {
                                this.$emit('addOrUpdateNode', data, this.nodeFlag)
                            } catch (error) {
                                this.$parent.initLazyDatasetTypeTree()
                            }
                        })
                    } else {
                        categoryAdd({ data }).then((r) => {
                            this.$message({
                                type: 'success',
                                message: '保存成功'
                            })
                            this.cancel()
                            try {
                                this.$emit('addOrUpdateNode', data, this.nodeFlag)
                            } catch (error) {
                                this.$parent.initLazyDatasetTypeTree()
                            }
                        })
                    }
                } else {
                    return false
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
@import "../../assets/style/common.scss";

::v-deep .el-select {
    width: 100%;
}
</style>
